/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable max-len */
import { useState } from 'react';

import FormValidator from '../../../../utilities/formValidator';
import PasswordErrors from '../../blocks/password-errors/password-errors';
import PasswordInput from '../password-input/password-input';

const PasswordWithErrorsInput = (props) => {
  const {
    inputId,
    inputName,
    label,
    errorsToShow, // must be an array with containing any combination of the following values ['length', 'upCase', 'lowCase', 'num', 'specialCharacter', 'pwMatch']
    pwMatch,
    checkPwMatch,
    updatePasswordErrorMessage,
    passwordErrorHolderId,
    lengthError,
    matchError,
  } = props;
  const [hasLength, setHasLength] = useState(null);
  const [pwLength, setPwLength] = useState(0);
  const [hasUpCase, setHasUpCase] = useState(null);
  const [hasLowCase, setHasLowCase] = useState(null);
  const [hasNum, setHasNum] = useState(null);
  const [hasSpecialCharacter, setHasSpecialCharacter] = useState(null);

  // form validators
  const includeLength = errorsToShow?.includes('length');
  const includesUpper = errorsToShow?.includes('upCase');
  const includesLower = errorsToShow?.includes('lowCase');
  const includesNumber = errorsToShow?.includes('num');
  const includesSpecial = errorsToShow?.includes('specialCharacter');
  const includesPwMatch = errorsToShow?.includes('pwMatch');

  const validatePassword = () => {
    const inputIdVal = document.getElementById(inputId).value;
    const pwValue = inputIdVal || '';
    setPwLength(pwValue.length);
    const formValidator = FormValidator();

    if (checkPwMatch != null) checkPwMatch();

    // Set Has
    if (includeLength) {
      setHasLength(pwValue.length >= 10);
      if (updatePasswordErrorMessage) {
        updatePasswordErrorMessage(pwValue.length);
      }
    }
    if (includesUpper) {
      setHasUpCase(formValidator.checkHasUpCase(pwValue));
    }
    if (includesLower) {
      setHasLowCase(formValidator.checkHasLowCase(pwValue));
    }
    if (includesNumber) {
      setHasNum(formValidator.checkHasNum(pwValue));
    }
    if (includesSpecial) {
      setHasSpecialCharacter(formValidator.checkHasSpecialCharacter(pwValue));
    }
  };

  const hasLengthError = includeLength || !lengthError;
  const hasUpCaseError = includesUpper && !hasUpCase;
  const hasLowCaseError = includesLower && !hasLowCase;
  const hasNumError = includesNumber && !hasNum;
  const hasSpecialCharacterError = includesSpecial && !hasSpecialCharacter;
  const hasPwMatchError = (includesPwMatch && !pwMatch) || !matchError;

  const hasError = ((pwLength && pwLength < 10) || (pwMatch === false)) && (hasLengthError || hasUpCaseError || hasLowCaseError || hasNumError || hasSpecialCharacterError || hasPwMatchError);

  const errorProps = {
    hasLength: hasLength || lengthError, hasUpCase, hasLowCase, hasNum, hasSpecialCharacter, passwordsMatch: pwMatch || matchError,
  };
  return (
    <>
      <PasswordInput inputId={inputId} inputName={inputName} label={label} onInputCallback={validatePassword} hasError={hasError} passwordErrorHolderId={passwordErrorHolderId} />
      {(hasError || pwMatch || hasLength) && (
        <div id="passwordErrorHolder">
          <PasswordErrors {...errorProps} errorsToShow={errorsToShow} hasLength={hasLength} passwordsMatch={pwMatch} />
        </div>
      )}

    </>
  );
};

export default PasswordWithErrorsInput;
